import { createStore } from "vuex";
import { user } from "./modules/user";
import { authentication } from "./modules/authentication";
import createPersistedState from "vuex-persistedstate";

const state = createPersistedState();

export const store = createStore({
  modules: {
    user,
    authentication,
  },
  plugins: [state],
});
